export const environment = {
  production: true
};

export const __APP_VERSION = 'V-new-kiwi-1.8.2-1';
